import {useLocaleStore} from '@frontend/stores'
import type {RegionConfig} from '@frontend/types/Locales'

// Хук для получения настроек региона.
export const useRegionConfig = (): RegionConfig => useLocaleStore(
    state => state.region
)
